import { lazy } from 'react';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
var ModuleLoaderLazy = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "notifications_shared" */
        './ModuleLoader');
    });
});
export default ModuleLoaderLazy;
//# sourceMappingURL=ModuleLoaderLazy.js.map